//import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";
import "./index.css";
import App from "./App.tsx";
import * as Sentry from "@sentry/react";

// 只在生产环境启用 Sentry
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://7fdfef88c8c846be5953b96de422186e@o4511057584390144.ingest.us.sentry.io/4511057697374208",
  });
}

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  // </StrictMode>,
);
